import { devtools } from 'zustand/middleware';

import { Filter, type FilterIterable } from '@pkg/classes';

const statusFilterOptions = ['hidden', 'visibleToEveryone'];
const statusFilterOptionsMarketPlace = ['hidden', 'visibleToEveryone', 'listed', 'hasOffers', 'spam'];

const chainFilterOptions = ['ethereum', 'aptos', 'polygon'];
const walletsFilterOptions = [];
const collectionsFilterOptions = [];

const availableIterable: FilterIterable = [
    ['status', statusFilterOptions],
    ['chain', chainFilterOptions],
    ['wallets', walletsFilterOptions],
    ['collections', collectionsFilterOptions],
];

const availableIterableMarketPlace: FilterIterable = [
    ['status', statusFilterOptionsMarketPlace],
    ['chain', chainFilterOptions],
    ['wallets', walletsFilterOptions],
    ['collections', collectionsFilterOptions],
];

const filtersIterable: FilterIterable = [
    ['status', []],
    ['chain', []],
    ['wallets', []],
    ['collections', []],
];

const availableFilterSet = new Filter(availableIterable);
export const availableFilterSetMarketPlace = new Filter(availableIterableMarketPlace);
const initialFilterSet = new Filter(filtersIterable);

import { create } from '@app/store/zustand/helpers/create';

interface State {
    availableFilters: Filter;
    currentFilters: Filter;
}
interface Actions {
    resetFilters: () => void;
    setAvailableFilters: (filters: State['availableFilters']) => void;
    setCurrentFilters: (filters: State['currentFilters']) => void;
}
const initialState: State = {
    availableFilters: availableFilterSet,
    currentFilters: initialFilterSet,
};

type NFTsFiltersStoreState = Actions & State;
export const useNFTsFiltersStore = create<NFTsFiltersStoreState>()(
    devtools(
        (set) => ({
            ...initialState,
            setAvailableFilters: (availableFilters) => set({ availableFilters }),
            setCurrentFilters: (currentFilters) => set({ currentFilters }),
            resetFilters: () =>
                set((state) => {
                    const filterOptionClone = new Filter(state.currentFilters);
                    filterOptionClone.forEach((_value, key) => filterOptionClone.set(key, []));
                    return { currentFilters: filterOptionClone };
                }),
        }),
        { name: 'nft-filter-store' },
    ),
);
